export default "__VITE_ASSET__Bi5tN2MO__"